import { render } from "./EditInfoFooterPage.vue?vue&type=template&id=8d7acfae&ts=true"
import script from "./EditInfoFooterPage.vue?vue&type=script&lang=ts"
export * from "./EditInfoFooterPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__